/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable no-return-assign */
/* eslint-disable react/no-unused-prop-types */
/* eslint-disable no-unused-vars */

/* eslint-disable react/prop-types */
/* eslint-disable react/forbid-prop-types */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Card, Col, Row } from 'react-bootstrap';
import AppButton from '../../../shared/components/app-button/AppButton';
import StarRating from './StarRating';
import {
  formatCurrency,
  getSupplierName,
  isMobileWidth,
} from '../../../shared/helper-utils/appUtils';
import { getUserAgentId } from '../../../shared/helper-utils/localStorage';
import FacilityIcons from './FacilityIcons';

const iconStyle = { fontSize: 18, marginRight: 4 };

function HotelCardV2({
  hotelData,
  onRoomChoose,
  showInvoiceFare,
  currencyOption,
  conversionRate,
  onShortList,
  shortListedHotels,
}) {
  const [isShortListed, setIsShortListed] = useState(false);

  const handleSelection = (e) => {
    e.stopPropagation();
    onShortList(hotelData);
  };

  const handlecheckBox = () => {
    const isPresent = shortListedHotels.some(
      (d) => d.pbKey === hotelData.pbKey,
    );
    setIsShortListed(isPresent);
  };

  useEffect(() => {
    handlecheckBox();
  }, [shortListedHotels]);
  const thumbnailSrc = hotelData?.thumbnail?.trim?.();
  const validSrc = thumbnailSrc || '/images/others/hotel-empty.jpg';
  const isValidThumbnail = thumbnailSrc && thumbnailSrc.startsWith('http');
  const fallback = '/images/others/hotel-empty.jpg';

  return (
    <Card className="hotel-card position-relative mb-2">
      <div
        className="hotel-card_container d-flex"
        role="button"
        tabIndex={0}
        onClick={() => onRoomChoose(hotelData)}
        style={{ cursor: 'pointer' }}
      >
        <div className="hotel-card__image">
          <img
            src={isValidThumbnail ? thumbnailSrc : fallback}
            alt="room"
            onError={(e) => {
              if (!e.currentTarget.src.includes('hotel-empty.jpg')) {
                e.currentTarget.src = fallback;
              }
            }}
          />
        </div>
        <div className="hotel-card__body d-flex flex-column flex-1">
          <div className="hotel-card__body_hotel-address-details">
            <Row className="spacing-0">
              <Col
                lg={10}
                md={10}
                sm={10}
                xs={12}
                className="d-flex flex-column"
              >
                <span
                  className="hotel-card__body__header_hotel-name"
                  title={hotelData.propertyName}
                >
                  {hotelData.propertyName}
                </span>
                <span
                  className="hotel-card__body__header_hotel-location"
                  title={hotelData.shortaddr}
                >
                  {hotelData.shortaddr}
                </span>
                <span className="fs-12 hotel-card__body__header_hotel-suppliername">
                  {getSupplierName(hotelData.rooms[0].providerName)}
                </span>
              </Col>
              <Col
                lg={2}
                md={2}
                sm={2}
                xs={12}
                className="d-flex flex-column hotel-rating"
              >
                <span
                  className="fs-8"
                  style={{ position: 'absolute', top: '5px' }}
                >
                  {/* {getSupplierName(hotelData.fareSource)} */}
                </span>
                <StarRating rating={hotelData?.starRating} />
                <span
                  className="fs-16 fw-600 hotel-results-watermarked w-100 text-sm-end text-start"
                  data-watermark={`${getUserAgentId()}`}
                >
                  {formatCurrency(hotelData.minPrice)}
                </span>
                {showInvoiceFare && (
                  <span
                    className="fs-12 fw-500 hotel-results-watermarked w-100  text-sm-end text-start"
                    data-watermark={`${getUserAgentId()}`}
                  >
                    {formatCurrency(hotelData.minPrice)}
                  </span>
                )}
              </Col>
            </Row>
          </div>
          <div className="hotel-card__body_hotel-amenities-details flex-1">
            <Row className="spacing-0">
              <Col
                lg={6}
                md={6}
                sm={6}
                xs={12}
                className="d-flex justify-content-start flex-column fs-12"
                title={hotelData.fcList.join(',')}
              >
                {/* {hotelData.am[0] && <span>{hotelData.am[0]}</span>}
                {hotelData.am[1] && <span>{hotelData.am[1]}</span>}
                {hotelData.am[1] && <span>{hotelData.am[2]}</span>}
                {hotelData.am.length > 3 && hotelData.am[2] && (
                  <span>+{hotelData.am.length - 3} More</span>
                )} */}
                <FacilityIcons hotelData={hotelData} showTitle={false} />
              </Col>
              <Col
                lg={6}
                md={6}
                sm={6}
                xs={12}
                className="d-flex align-items-end flex-column"
              >
                <div className="d-flex justify-content-end gap-2 flex-sm-row ">
                  <AppButton
                    variant={isShortListed ? 'secondary' : 'outlined'}
                    btnText={isShortListed ? 'Shortlisted' : 'Shortlist'}
                    onClick={handleSelection}
                    className="fs-12 px-3 hotel-card__body__action-btn"
                  />
                  <AppButton
                    variant="select"
                    btnText={isMobileWidth() ? 'Select' : 'Select Room'}
                    onClick={() => onRoomChoose(hotelData)}
                    className="fs-12 px-3 hotel-card__body__action-btn"
                  />
                </div>
              </Col>
            </Row>
          </div>
        </div>
      </div>
    </Card>
  );
}

HotelCardV2.propTypes = {
  hotelData: PropTypes.object.isRequired,
  onRoomChoose: PropTypes.func.isRequired,
  showInvoiceFare: PropTypes.bool.isRequired,
  currencyOption: PropTypes.any.isRequired,
  conversionRate: PropTypes.any.isRequired,
  onSelectForShortList: PropTypes.func.isRequired,
  onShortList: PropTypes.func.isRequired,
  shortListedHotels: PropTypes.array.isRequired,
  index: PropTypes.number.isRequired,
};

export default HotelCardV2;
